import React from 'react';
import type { HeadProps, PageProps } from 'gatsby';
import { graphql } from 'gatsby';
import { PostsPage } from './posts';
import SEO from '../components/SEO';

type CategoryPageContext = {
    title: string;
    category: string;
    currentPage: number;
    postsLimit: number;
    postsOffset: number;
    prevPagePath: string;
    nextPagePath: string;
    hasPrevPage: boolean;
    hasNextPage: boolean;
};

const CategoryPage = (
    props: PageProps<Queries.CategoryPageQuery, CategoryPageContext>,
) => <PostsPage {...props} />;

export const Head = ({
    pageContext,
    location,
}: HeadProps<Queries.TagPageQuery, CategoryPageContext>) => (
    <SEO
        title={`Posts in ${pageContext.category}`}
        description={undefined}
        pathname={location.pathname}
    />
);

export const query = graphql`
    query CategoryPage(
        $postsLimit: Int!
        $postsOffset: Int!
        $category: String!
    ) {
        postFiles: allFile(
            filter: {
                sourceInstanceName: { eq: "posts" }
                childMdx: { frontmatter: { category: { eq: $category } } }
            }
            sort: { name: DESC }
            limit: $postsLimit
            skip: $postsOffset
        ) {
            nodes {
                childMdx {
                    id
                    excerpt
                    frontmatter {
                        title
                        slug
                        excerpt
                        tags
                        category
                        date
                        thumb
                    }
                }
            }
        }
    }
`;

export default CategoryPage;
